(function () {
  'use strict';

  angular.module('app').component('addonsPage', addonListComponent());

  function addonListComponent() {
    return {
      controller: AddonListCtrl,
      controllerAs: 'vm',
      bindings: {},
      templateUrl: './app/ajs/admin/addons/addons-page.component.html',
    };
  }

  AddonListCtrl.$inject = ['UtilService', 'AddonService', 'LanguageService', 'FeatureService'];

  function AddonListCtrl(UtilService, AddonService, LanguageService, FeatureService) {
    var vm = this;

    var utils = new UtilService(vm);

    // Methods
    vm.createItem = createItem;
    vm.onShowItem = onShowItem;

    // Initializers
    getItems('');
    getFeatures();
    getAdditionalLanguages();

    function getItems(selectedItem) {
      vm.loadingItems = true;

      AddonService.getAddons().then(function (data) {
        vm.items = data.items;
        vm.meta = data.meta;

        vm.loadingItems = false;

        if (selectedItem) {
          utils.itemListChanged(selectedItem.id);
        }
      });
    }

    function getFeatures() {
      FeatureService.getFeatures({ get: 'visible_as_addon', skip_check_role: true }).then(function (
        data
      ) {
        vm.features = data.items;
        //vm.features.unshift(anyFeature);
      });
    }

    function getAdditionalLanguages() {
      LanguageService.getLanguages({ get: 'translations', skip_check_role: true }).then(function (
        data
      ) {
        vm.additionalLanguages = data.items;
      });
    }

    function createItem() {
      AddonService.openAddonModal({}, vm.additionalLanguages, 'create', vm.features, getItems);
    }

    function onShowItem(item, mode) {
      AddonService.openAddonModal(item, vm.additionalLanguages, mode, vm.features);
    }
  }
})();
